
import React from "react";
import BookingForm from "../components/BookingForm";

const SecundaBaltimoreSuites= () => {
  return (
    <div className="bg-[#F2F1F0] text-[#144E73] font-sans min-h-screen pt-16 pb-20 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-primarymb-10 text-center">
          Secunda – Baltimore SC – Self-Catering
        </h1>

        {/* Gallery + Description */}
        <div className="grid md:grid-cols-2 gap-10 mb-16 items-start">
          {/* Gallery */}
          <div className="grid grid-rows-[auto_1fr] gap-4">
            <img

                src={`/images/secunda/main-image.jpg`}
                alt={`Secunda Main`}
                className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
            />
            <div className="grid grid-cols-2 gap-4">
              {[...Array(5)].map((_, i) => (
                  <img
                      key={i}
                      src={`/images/secunda/image-${i + 1}.png`}
                      alt={`Secunda Gallery ${i + 1}`}
                      className="rounded-lg aspect-[4/3] object-cover border-4 border-[#FEB339]"
                  />

              ))}
            </div>
          </div>

          {/* Description */}
          <div>
            <p className="text-lg leading-relaxed mb-4">
              Baltimore SC offers spacious and well-equipped 3-bedroom units in Secunda — perfect for families or groups. Designed for comfort and practicality, it’s an ideal base for long stays or business trips.
            </p>
            <ul className="list-disc ml-5 text-sm space-y-2">
              <li>3-bedroom units (sleeps 6)</li>
              <li>DSTV and laundry service</li>
              <li>Secure private parking</li>
              <li>Outdoor braai area</li>
            </ul>

          </div>
        </div>


        {/* Booking Form */}

        <BookingForm hotelName="Secunda Baltimore Suites"/>

      </div>
    </div>
  );
};

export default SecundaBaltimoreSuites;
